import { useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { comics } from "@/mocks/comics";
import ComicCard from "@/components/base/ComicCard";

const sortOptions = [
  { key: "hot", label: "人气最高" },
  { key: "latest", label: "最新更新" },
  { key: "rating", label: "评分最高" },
];

export default function CategoryPage() {
  const { slug = "all" } = useParams();
  const [sort, setSort] = useState("hot");

  const current = categories.find((c) => c.slug === slug);
  const catName = slug === "all" ? "全部" : current?.name ?? "全部";

  const list = useMemo(() => {
    const base = slug === "all" ? [...comics] : comics.filter((c) => c.category === slug);
    if (sort === "rating") return [...base].sort((a, b) => b.rating - a.rating);
    if (sort === "latest") return [...base].sort((a, b) => (a.updateDate === "今天" ? -1 : 1) - (b.updateDate === "今天" ? -1 : 1));
    return [...base].sort((a, b) => parseFloat(b.views.replace(/[万亿]/g, "")) - parseFloat(a.views.replace(/[万亿]/g, "")));
  }, [slug, sort]);

  return (
    <div className="w-full mx-auto px-4 md:px-6 py-6 md:py-8">
      <div className="max-w-7xl mx-auto">
        <nav className="text-sm text-foreground-500 mb-5 flex flex-wrap items-center gap-1.5" aria-label="面包屑导航">
          <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
          <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center" aria-hidden="true" />
          <Link to="/category/all" className="hover:text-primary-600 transition-colors">漫画分类</Link>
          <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center" aria-hidden="true" />
          <span className="text-foreground-700">{catName}漫画</span>
        </nav>

        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-6">
          <div>
            <h1 className="font-heading text-2xl md:text-3xl text-foreground-900">
              {catName}漫画合集
            </h1>
            <p className="mt-2 text-sm text-foreground-600">
              {slug === "all"
                ? "汇集全站海量漫画资源，支持分类浏览与下拉式免费阅读。"
                : current?.description}
            </p>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2 mb-6">
          <Link
            to="/category/all"
            className={`rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors ${
              slug === "all" ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-900 hover:bg-secondary-200"
            }`}
          >
            全部
          </Link>
          {categories.map((c) => (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className={`rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors flex items-center gap-1.5 ${
                slug === c.slug ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-900 hover:bg-secondary-200"
              }`}
            >
              <i className={`${c.icon} w-4 h-4 flex items-center justify-center`} aria-hidden="true" />
              {c.name}
            </Link>
          ))}
        </div>

        <div className="flex items-center justify-between mb-6">
          <p className="text-sm text-foreground-600">
            共 <strong className="text-primary-600">{list.length}</strong> 部漫画
          </p>
          <div className="flex items-center gap-1 rounded-full bg-background-100 border border-background-200/70 p-1">
            {sortOptions.map((o) => (
              <button
                key={o.key}
                type="button"
                onClick={() => setSort(o.key)}
                className={`rounded-full px-4 py-1.5 text-sm whitespace-nowrap cursor-pointer transition-colors ${
                  sort === o.key ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:text-primary-600"
                }`}
              >
                {o.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {list.map((c) => (
            <ComicCard key={c.id} comic={c} />
          ))}
        </div>
      </div>
    </div>
  );
}